/* ============================================================
   URINKING · Kopfzeile
   Angelegt 02.08.2026.

   WAS DAS SKRIPT TUT - und was bewusst NICHT:

   Das Auf- und Zuklappen macht <details>/<summary> selbst. Damit
   funktioniert das Menue mit Tastatur, mit Vorleseprogramm und
   ohne JavaScript. Dieses Skript legt nur darueber:

     1. beim Oeffnen die anderen Aufklapper schliessen
     2. Klick daneben und Escape schliessen
     3. am Rechner mit Maus: Ueberfahren oeffnet, mit kurzer
        Verzoegerung gegen versehentliches Aufreissen
     4. die mobile Schublade auf- und zuklappen

   ES BAUT NICHTS NACH, was der Browser schon kann. Kein eigener
   Fokus-Kaefig, kein eigenes Tastaturmodell, keine Bibliothek -
   dasselbe Vorgehen wie beim Hero-Schieber und der Trust-Leiste.
   ============================================================ */

class UkHeader extends HTMLElement {
  connectedCallback() {
    this.aufklapper = Array.from(this.querySelectorAll('[data-auf]'));
    this.burger = this.querySelector('[data-burger]');
    this.schublade = this.querySelector('[data-schublade]');

    /* Ueberfahren nur, wo es ein Zeigegeraet gibt. Auf einem
       Touchscreen loest hover beim Tippen mit aus - der Aufklapper
       ginge auf und im selben Moment wieder zu. */
    this.zeigegeraet = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.verzoegerung = null;

    this.aufklapper.forEach((d) => this.#aufklapperVerdrahten(d));

    if (this.burger && this.schublade) this.#burgerVerdrahten();

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.#allesZu(true);
    });

    /* Klick ausserhalb. Am Dokument, nicht am Element - sonst
       bekaeme man Klicks daneben nie zu sehen. */
    this.klickDaneben = (e) => {
      if (!this.contains(e.target)) this.#allesZu(false);
    };
    document.addEventListener('click', this.klickDaneben);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.klickDaneben);
    clearTimeout(this.verzoegerung);
  }

  #aufklapperVerdrahten(d) {
    const punkt = d.querySelector('[data-punkt]');

    d.addEventListener('toggle', () => {
      if (!d.open) return;
      this.aufklapper.forEach((a) => {
        if (a !== d) a.open = false;
      });
    });

    if (!punkt) return;

    d.addEventListener('mouseenter', () => {
      if (!this.zeigegeraet.matches) return;
      clearTimeout(this.verzoegerung);
      /* 110ms: lang genug, dass ein Mauszeiger auf dem Weg zur
         Symbolreihe nicht drei Aufklapper aufreisst; kurz genug,
         dass es sich nicht traege anfuehlt. */
      this.verzoegerung = setTimeout(() => { d.open = true; }, 110);
    });

    d.addEventListener('mouseleave', () => {
      if (!this.zeigegeraet.matches) return;
      clearTimeout(this.verzoegerung);
      this.verzoegerung = setTimeout(() => { d.open = false; }, 160);
    });

    /* Beim Tippen auf einem Touchscreen soll der erste Tipp oeffnen
       und nicht dem Link folgen. summary macht das von selbst -
       hier wird nur verhindert, dass ein zweiter Klick waehrend der
       Hover-Verzoegerung sofort wieder schliesst. */
    punkt.addEventListener('click', () => clearTimeout(this.verzoegerung));
  }

  #burgerVerdrahten() {
    this.burger.addEventListener('click', () => {
      const offen = this.burger.getAttribute('aria-expanded') === 'true';
      this.#schubladeSetzen(!offen);
    });

    /* Wird das Fenster auf Rechnerbreite gezogen, muss die Schublade
       zu sein. Sonst bleibt sie im Zustand "offen" haengen und das
       naechste Verkleinern zeigt sie ohne Zutun wieder an. */
    const breit = window.matchMedia('(min-width: 990px)');
    breit.addEventListener('change', (e) => {
      if (e.matches) this.#schubladeSetzen(false);
    });
  }

  #schubladeSetzen(offen) {
    this.burger.setAttribute('aria-expanded', String(offen));
    this.schublade.hidden = !offen;
  }

  #allesZu(auchSchublade) {
    clearTimeout(this.verzoegerung);
    this.aufklapper.forEach((a) => { a.open = false; });
    if (auchSchublade && this.burger && this.schublade) {
      const warOffen = this.burger.getAttribute('aria-expanded') === 'true';
      this.#schubladeSetzen(false);
      /* Nach Escape gehoert der Fokus zurueck auf den Burger,
         sonst steht er im Nichts. */
      if (warOffen) this.burger.focus();
    }
  }
}

if (!customElements.get('uk-header')) {
  customElements.define('uk-header', UkHeader);
}
